import React from 'react';
import {connect} from 'react-redux';
import {SEARCHBYTESTKEY, FEIDEDROPDOWN, CONEXUSDROPDOEN, SIMULATE_RESULTS} from 'constants/index';
import './styles.scss';
import SearchByTestKey from 'pages/SearchByTestKey';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faXmark} from '@fortawesome/free-solid-svg-icons';
import strings from 'utils/strings';
import DumpTests from 'pages/MyTests/DumpTests';
import FeideTwo from 'components/FeideTwo';
import Conexus from 'components/Conexus';
import SimulateTestResult from 'pages/SimulateTestResult';

class Tests extends React.Component {
	constructor() {
		super();

		this.state = {
			activeFilter: SEARCHBYTESTKEY,
			isDumpingTests: false,
		};
	}

	render() {
		const {activeFilter, isDumpingTests} = this.state;
		const {isSuperAdmin} = this.props;
		const testsFilters = [
			SEARCHBYTESTKEY,
			FEIDEDROPDOWN,
			CONEXUSDROPDOEN,
			...(isSuperAdmin ? [SIMULATE_RESULTS] : []),
		];

		return (
			<div>
				<div className="lit-test-section-drop-down">
					<div className="lit-dropdown_filter">
						<select
							className="lit-input__field"
							defaultValue={SEARCHBYTESTKEY.id}
							onChange={(e) => {
								this.setState({
									activeFilter: testsFilters.filter(
										(filter) => filter.id === e.target.value
									)[0],
								});
							}}
						>
							{testsFilters.map((userStageFilter) => (
								<option
									key={userStageFilter.id}
									value={userStageFilter.id}
								>
									{userStageFilter.label ||
										userStageFilter.text}
								</option>
							))}
						</select>
					</div>
					{activeFilter !== SIMULATE_RESULTS && (
						<div>
							<button
								className="lit-mytests-header-mytest-btn-ternary"
								onClick={() => {
									this.setState({
										isDumpingTests: true,
									});
								}}
							>
								<FontAwesomeIcon
									className="lit-icon-btns"
									icon={faXmark}
								/>
								<p className="lit-btns-txt">
									{strings.deleteoldtests}
								</p>
							</button>
						</div>
					)}
				</div>

				{activeFilter === SEARCHBYTESTKEY && (
					<div className="lit-search-by-test-key">
						<SearchByTestKey />
					</div>
				)}
				{activeFilter === FEIDEDROPDOWN && (
					<div className="lit-search-by-test-key">
						<FeideTwo />
					</div>
				)}

				{activeFilter === CONEXUSDROPDOEN && (
					<div className="lit-search-by-test-key">
						<Conexus />
					</div>
				)}

				{activeFilter === SIMULATE_RESULTS && isSuperAdmin && (
					<div className="lit-simulate-wrapper">
						<SimulateTestResult />
					</div>
				)}

				{isDumpingTests && (
					<DumpTests
						closeWindow={() => {
							this.setState({
								isDumpingTests: false,
							});
						}}
					/>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {currentUser} = state;
	return {
		isSuperAdmin: currentUser?.isSuperAdmin || false,
	};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Tests);
